import { Item } from "./Item";
import { Layout } from "./Layout";

Layout.Item = Item;

export default Layout;
